import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ArrowSpinnable",
  "use": "ArrowSpinnable-usage",
  "content": "<symbol id=\"ArrowSpinnable\"><polygon fill=\"currentColor\" points=\"8.32308264 2 5 5.22785648 1.67691736 2 0.25 3.38602765 5 7.99991178 9.75 3.38602765\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol